import { cn } from "@/lib/utils";

export function ChatBubble({
  role,
  className,
  children,
}: {
  role: "user" | "assistant";
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={cn("flex items-center", role === "user" && "justify-end")}>
      <div
        className={cn(
          "flex flex-col gap-2 p-2 text-sm text-primary/70",
          role === "user" &&
            "bg-primary/5 rounded-lg border border-[#EDEDF0] dark:border-[#2D2D31] [box-shadow:0_2px_0_0_rgba(255,255,255,0.16)_inset] dark:[box-shadow:0_1px_0_0_rgba(255,255,255,0.08)_inset]",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
